<!-- 捐赠详细信息页面
捐赠指数页面点击推荐项目跳转至该页面
捐赠推荐项目页面点击没有更多了之后 跳转至该页面-
我的捐赠页面点击再次捐赠 跳转至该页面-> -->
<template>
  <div class="donationDetailRoot">
    <div class="nav">
      <div class="navDiv clearfix">
        <div
          class="detailsNav"
          @click="checkNav('profilesIdNav')"
          id="profilesIdNav"
          style="color: #00706e; font-size: 1.1rem; font-weight: bold"
        >
          项目详情
        </div>
        <div
          class="detailsNav"
          @click="checkNav('thanksIdNav')"
          id="thanksIdNav"
        >
          捐赠鸣谢
        </div>
        <div class="detailsNav" @click="checkNav('backIdNav')" id="backIdNav">
          项目回报
        </div>
        <div
          class="detailsNav"
          @click="checkNav('contentUsIdNav')"
          id="contentUsIdNav"
        >
          联系我们
        </div>
      </div>
    </div>
    <div class="donationDetail">
      <div class="recommend">
        <div class="recommendImgDiv">
          <div class="recommendTipDiv">
            <div class="recommendTipWord">
              {{ this.donationDetail.typeName }}
            </div>
          </div>
          <img
            :src="this.donationDetail.images"
            alt="项目图片"
            class="recommendImg"
          />
          <div class="supportNumDiv">
            <div class="endTime">
              捐赠截止日期：{{ this.donationDetail.endAt }}
            </div>
            <!-- <div class="supportNum">支持人数 {{ this.donationNum }} 人</div> -->
          </div>
        </div>
        <div class="recommendCardDiv clearfix">
          <div class="recommendName">{{ this.donationDetail.title }}</div>
          <div class="recommendState" v-if="this.donationDetail.status == 1">
            进行中
          </div>
          <div
            class="recommendState"
            v-else-if="this.donationDetail.status == 3"
          >
            未开始
          </div>
          <div class="recommendState" v-else>已结束</div>
          <div class="maxMoney">
            目标金额：￥{{ this.donationDetail.targetAmount }}元
          </div>
          <!-- <div class="nowMoney">
            已筹金额：￥{{ this.donationDetail.hasAmount }}元
          </div> -->
         <!-- 先渲染0在渲染数据 -->
          <!-- <div class="percentageDiv clearfix">
            <div class="percentageWord">捐款进度</div>
            <van-progress
              :percentage="
                (this.donationDetail.hasAmount /
                  this.donationDetail.targetAmount) *
                  100 || 0
              "
              stroke-width="15"
              :show-pivot="false"
              class="percentage"
            />
            <div class="percentageNum">
              {{
                (
                  (donationDetail.hasAmount / donationDetail.targetAmount) *
                    100 +
                  ""
                ).substring(0, 3) + "%"
              }}
            </div>
          </div> -->
        </div>
      </div>
      <div class="profiles" id="profilesId">
        <div class="titleDiv">
          <div class="FirstLevelTitle">
            <div>项目详情</div>
          </div>
          <button class="statement" v-show="false" @click="showExplain">免税声明</button>
        </div>
        <div class="profilesWords" id="profilesWordsId"></div>
      </div>
      <div class="thanks" id="thanksId">
        <div class="titleDiv">
          <div class="FirstLevelTitle">
            <div>捐赠鸣谢</div>
          </div>
          <div class="activeMore" v-show="false" @click="gotoRanking">更多</div>
        </div>
        <div class="table" style="overflow: auto">
          <el-table
            :data="donationDetail.donateUsers || []"
            height="250"
            :border="false"
            style="width: 100%; border-radius: 15px"
          >
            <el-table-column prop="name" label="捐赠人"> </el-table-column>
            <el-table-column label="捐赠金额">
              <template slot-scope="scope">{{ scope.row.totalMoney }}元</template>
            </el-table-column>
            <el-table-column prop="createdAt" width="150px" label="捐赠时间">
            </el-table-column>
          </el-table>
        </div>
        <div class="back" id="backId">
          <div class="titleDiv">
            <div class="FirstLevelTitle">
              <div>项目回报</div>
            </div>
          </div>
          <div class="backWords" id="backWordsId"></div>
        </div>
        <div class="contentUs" id="contentUsId">
          <div class="titleDiv">
            <div class="FirstLevelTitle">
              <div>联系我们</div>
            </div>
          </div>
          <div class="tel">
            联系人：{{ this.donationDetail.name }}&nbsp;&nbsp;<a
              :href="'tel' + ':' + this.donationDetail.telephone"
              ><img
                src="../../assets/image/btn_dianhua_nor.png"
                alt="电话"
                class="telIcon"
            /></a>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom clearfix">
      <!-- <div class="share" @click="showShare = true">
        <img
          src="../../assets/image/btn_fenxiang_nor.png"
          class="shareIcon"
          alt="分享"
        />&nbsp;&nbsp;分享
        <van-share-sheet
          v-model="showShare"
          title="立即分享给好友"
          :options="options"
          @select="share"
        />
      </div>  -->
      <div
        class="donating"
        v-if="donationDetail.status == 1"
        @click="showDonating"
      >
        我要捐款
      </div>
    </div>

    <div class="popup">
      <!-- @open打开弹出层时触发 -->
      <van-popup
        v-model="show"
        round
        :style="{ height: '70%', width: '90%' }"
        @opened="popupExplainWord"
      >
        <div class="topImgDiv">
          <img
            src="../../assets/image/btn_shang_nor.png"
            alt="顶部图片"
            class="topImg"
          />
        </div>
        <div class="popupExplain">公益捐赠免税计算方法说明</div>
        <div class="popupExplainWords" id="popupExplainWordsId"></div>
        <div class="popupBtnDiv">
          <button
            v-if="donationDetail.status == 1"
            class="popupBtn"
            @click="onPopupExplainDonate"
          >
            去捐赠
          </button>
        </div>
        <div class="bottomImgDiv">
          <img
            src="../../assets/image/btn_xia_nor.png"
            alt="底部图片"
            class="bottomImg"
          />
        </div>
      </van-popup>
    </div>

    <div class="showDonating">
      <van-action-sheet v-model="donatingShow">
        <div class="part clearfix" id="partId" @click="clickPart">
          <div class="partTitle">
            捐赠份数（{{ donationDetail.eachAmount }}元/份，1份起）
          </div>
          <div class="partNum">
            <van-stepper v-model="postDonatingData.number" />
          </div>
        </div>
        <div class="customMoney" @click="changePartStyle">
          <el-input
            v-model="customMoney"
            placeholder="自定义金额"
            @input="onCustomMoneyInput"
            @keyup.enter.native="donating"
          >
            <i class="customMoneyUnit" slot="suffix">元</i>
          </el-input>
        </div>
        <div class="showButtonDiv">
          <button class="showBtn" :disabled="submitting" @click="donating">
            {{ submitting ? "提交中…" : "捐款" }}
          </button>
        </div>
      </van-action-sheet>
    </div>
  </div>
</template>
<script src="https://res2.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
import wx from "weixin-js-sdk";
export default {
  data() {
    return {
      openid: window.localStorage.getItem("openid"),
      // openid: "oKMob64cF73I3t5_sivE238GkSGY",
      // openid:"oKMob6w6at7ondTvoUyTuR-pNneA",
      donationDetail: "",
      show: false,
      donatingShow: false,
      // showShare: false,
      // options: [
      //   { name: "微信", icon: "wechat" },
      //   { name: "复制链接", icon: "link" },
      // ],
      donationNum: "",
      // 自定义金额
      customMoney: "",
      // 是否正在提交
      submitting: false,
      // 份数还是自定义金额，0是份数，1是自定义金额
      isCustomMoney: 0,
      wxPayData: "",
      postDonatingData: {
        donateId: this.$route.query.id,
        openId: window.localStorage.getItem("openid"),
        number: 1,
        price: "",
      },
      postShare: {
        openid: window.localStorage.getItem("openid"),
      },
      weixin: "",
      taxDeclaration: "",
    };
  },
  created() {
    window.localStorage.setItem("donateId", this.$route.query.id);
    window.localStorage.setItem("openidDona", this.openid);
    this.getDonationDetail();
    this.getTaxDeclaration();
  },
  methods: {
    async getDonationDetail() {
      const result = await this.$http.get("/donates/getDonateById", {
        params: { id: this.$route.query.id, openid: this.openid },
      });
      console.log({ result });
      this.donationDetail = result.data;
      this.donationNum = result.data.persons;
      // 初始化默认按份数捐款
      this.postDonatingData.price = this.donationDetail.eachAmount;
      document.getElementById("backWordsId").innerHTML =
        this.donationDetail.report;
      document.getElementById("profilesWordsId").innerHTML =
        this.donationDetail.detail;
    },
    checkNav(id) {
      //  获取所有具有 "detailsNav" 类名的元素
      var nav = document.getElementsByClassName("detailsNav");
      // 循环遍历所有具有 "detailsNav" 类名的元素
      for (let i = 0; i < nav.length; i++) {
        // 将导航元素的样式重置为默认值
        nav[i].style.color = "gray";
        nav[i].style.fontSize = "1rem";
        nav[i].style.fontWeight = "normal";
      }
      // 设置被点击的导航元素的样式为高亮
      document.getElementById(id).style.color = "#00706E";
      document.getElementById(id).style.fontSize = "1.1rem";
      document.getElementById(id).style.fontWeight = "bold";
      // 去掉字符串Nav，拼接成跳转的id 例 id=profilesIdNav ids = profilesId
      // 根据传入的id，去掉末尾的 "Nav"，以获取滚动到的目标元素的id
      var ids = "#" + id.slice(0, -3);
      // 使用scrollIntoView方法滚动到指定id的元素
      document.querySelector(ids).scrollIntoView(true);
    },
    showExplain() {
      this.show = true;
    },
    async getTaxDeclaration() {
      const result = await this.$http.get("/donates/getTaxDeclaration");
      this.taxDeclaration = result.data.content;
    },
    popupExplainWord() {
      document.getElementById("popupExplainWordsId").innerHTML =
        this.taxDeclaration;
    },
    onPopupExplainDonate() {
      this.closePopup();
      this.showDonating();
    },
    closePopup() {
      this.show = false;
    },
    gotoRanking() {
      return this.$router.push("/ranking");
    },
    showDonating() {
      this.donatingShow = true;
    },
    clickPart() {
      document.getElementById("partId").style.borderColor = "#00706E";
      this.isCustomMoney = 0;
      this.customMoney = "";
    },
    changePartStyle() {
      document.getElementById("partId").style.borderColor = "#DCDCDC";
      this.isCustomMoney = 1;
    },
    // 自定义金额只允许数字（最多两位小数）
    onCustomMoneyInput() {
      let v = String(this.customMoney == null ? "" : this.customMoney);
      v = v.replace(/[^\d.]/g, "");
      const dotIndex = v.indexOf(".");
      if (dotIndex !== -1) {
        v =
          v.slice(0, dotIndex + 1) +
          v.slice(dotIndex + 1).replace(/\./g, "").slice(0, 2);
      }
      this.customMoney = v;
    },
    // 捐赠，微信支付
    async donating() {
      if (this.submitting) {
        return;
      }
      try {
        this.submitting = true;
        // Android 软键盘开启时先收起键盘，避免第一次点击只收起键盘、不触发按钮
        if (document.activeElement && document.activeElement.blur) {
          document.activeElement.blur();
        }
        if (
          this.customMoney == 0 ||
          this.customMoney == 0.0 ||
          this.customMoney == ""
        ) {
          if (this.postDonatingData.number == 1) {
            this.customMoney = 1;
          } else {
            this.customMoney = this.postDonatingData.number * 1;
          }
        }
        const openid = window.localStorage.getItem("openid") || "";
        const donateId = this.$route.query.id;
        const number = this.postDonatingData.number;
        const price = this.customMoney;

        // 自定义金额必须是有效数字
        if (isNaN(Number(price)) || Number(price) <= 0) {
          this.submitting = false;
          this.$toast("请输入正确的捐赠金额");
          return;
        }

        // 后续跳转到捐赠成功填写信息页，需要这个金额参数
        window.sessionStorage.setItem("totalMoney", price);

        console.log("[donate] 开始下单", { openid, donateId, number, price });
        let results;
        try {
          results = await this.$http({
            url: "/donates/insertDonateRecord",
            method: "POST",
            data: {
              openIdGgh: openid,
              donateId: donateId,
              number: number,
              totalMoney: price,
            },
          });
        } catch (e) {
          this.submitting = false;
          console.error("[donate] 下单请求失败", e);
          this.$toast("下单失败，请稍后重试");
          return;
        }
        console.log("[donate] 下单响应", results && results.data);
        if (!results || results.data !== true) {
          const msg =
            (results && results.data && results.data.msg) || "下单失败";
          this.submitting = false;
          console.error("[donate] 下单未成功", results && results.data);
          this.$toast(msg);
          return;
        }

        const returnUrl = encodeURIComponent(
          window.location.origin + "/donationDetail?id=" + donateId
        );
        const payUrl =
          `/pages/payment/payment?openIdGgh=${encodeURIComponent(openid)}` +
          `&donateId=${donateId}&number=${number}&price=${price}` +
          `&returnUrl=${returnUrl}`;
        console.log("[donate] 跳转小程序支付页", payUrl);
        wx.miniProgram.redirectTo({
          url: payUrl,
          success: () => {
            this.submitting = false;
            console.log("[donate] 跳转支付页成功");
          },
          fail: (err) => {
            this.submitting = false;
            console.error("[donate] 跳转支付页失败", err);
            this.$toast(
              "跳转支付页失败：" +
                ((err && err.errMsg) || JSON.stringify(err))
            );
          },
        });
      } catch (e) {
        this.submitting = false;
        console.error("[donate] donating 异常", e);
        this.$toast("操作失败：" + (e && e.message ? e.message : e));
      }
    },
  },
};
</script>
<style lang="less" scoped>
.donationDetailRoot {
  display: flex;
  flex-direction: column;
  padding: 0;
  height: calc(100vh - 46px);
  padding: 0 !important;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.nav {
  flex: 0 0 auto;
  background-color: #edf6f3;
  width: 100%;
}

.navDiv {
  position: relative;
  left: 5%;
  width: 90%;
}

.detailsNav {
  float: left;
  width: 25%;
  padding: 10px 0px 10px 0px;
  text-align: center;
  color: gray;
  font-size: 1.1rem;
}

a:link {
  color: gray;
  text-decoration: none;
}

a:visited {
  color: gray;
  text-decoration: none;
}

a:hover {
  color: gray;
  text-decoration: none;
}

.donationDetail {
  flex: 1 1 auto;
  min-height: 0;
  position: relative;
  padding: 3vh 0;
  overflow: auto;
}

.donationDetail::-webkit-scrollbar {
  display: none;
}

.recommend {
  position: relative;
  left: 5%;
  width: 90%;
  margin: 0px 0px 20px 0px;
}

.recommendImgDiv {
  position: relative;
  width: 100%;
  height: 20vh;
}

.recommendImg {
  width: 100%;
  height: 100%;
  border-radius: 15px 15px 0 0;
}

.recommendTipDiv {
  position: absolute;
  left: 0%;
  top: 0%;
  width: 35%;
  height: 25px;
  line-height: 25px;
  background: linear-gradient(-90deg, #00706e, #00706e);
  border-radius: 15px 0px 15px 0px;
}

.recommendTipWord {
  color: white;
  white-space: nowrap;
  text-align: center;
}

.recommendTip {
  width: 100%;
}

.supportNumDiv {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #000000;
  opacity: 0.7;
}

.endTime {
  float: left;
  color: white;
  padding: 5px 10px 5px 5px;
  font-size: 0.9rem;
}

.supportNum {
  float: right;
  color: white;
  padding: 5px 10px 5px 0px;
}

.recommendCardDiv {
  background-color: white;
  border-radius: 0px 0px 15px 15px;
}

.recommendName {
  float: left;
  width: 80%;
  font-size: 1rem;
  font-weight: bold;
  margin: 5px 0px 5px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.recommendState {
  float: right;
  width: 14%;
  color: #00706e;
  font-size: 1rem;
  font-weight: bold;
  padding: 5px 5px 5px 0px;
}

.maxMoney {
  float: left;
  color: #666666;
  padding: 5px 0px 5px 10px;
  width: 50%;
  font-size: 0.9rem;
}

.nowMoney {
  float: right;
  color: #666666;
  margin: 5px 0px 5px 0px;
  width: 40%;
  font-size: 0.9rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.percentageDiv {
  float: left;
  width: 100%;
  margin-bottom: 10px;
}

.percentageWord {
  float: left;
  color: #666666;
  padding: 5px 0px 5px 10px;
  font-size: 0.9rem;
}

.percentage {
  float: left;
  width: 60%;
  margin: 5px 0px 5px 10px;
}

.percentageNum {
  float: right;
  color: #666666;
  padding: 5px 10px 5px 0px;
}

.profiles {
  position: relative;
  left: 5%;
  width: 90%;
}

.titleDiv {
  height: 7vw;
  display: flex;
  flex-direction: row;
}

.activeTitleIcon {
  float: left;
  width: 4px;
  height: 6vw;
  background-color: #00706e;
  border-radius: 15px;
}

.activeTitleWord {
  float: left;
  position: absolute;
  left: 10px;
  font-size: 1.3em;
  font-weight: bold;
}

.activeMore {
  float: right;
  color: #00706e;
  border: 0;
  // background: #f5f5f5;
  width: 50px;
}

.statement {
  float: right;
  width: 80px;
  color: #00706e;
  background: white;
  border-radius: 15px;
  border-color: #00706e;
  border-style: solid;
  border-width: 1px;
  padding-top: 2px;
  padding-bottom: 2px;
  font-size: 0.9rem;
}

.profilesWords {
  background-color: white;
  margin-top: 10px;
  border-radius: 15px;
  padding: 0.56rem 0.72rem;

  text-indent: 2em;
  word-wrap: break-word;
  word-break: break-all;

  font-size: 1.07rem;
  color: #666666;
  line-height: 2.13rem;

  /deep/ p {
    margin-block: 0;
  }
}

.thanks {
  margin-top: 20px;
  position: relative;
  left: 5%;
  width: 90%;
}

.table {
  margin-top: 10px;
}

/deep/ .el-table th.el-table__cell > .cell {
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
  color: #00706e;
}

/deep/ .el-table .cell {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding-right: 10px;
  text-align: center;
}

.back {
  margin-top: 20px;
}

.backWords {
  background-color: white;
  margin-top: 10px;
  border-radius: 15px;
  padding: 0.56rem 0.72rem;
  word-wrap: break-word;
  word-break: break-all;

  font-size: 1.07rem;
  color: #666666;
  line-height: 2.13rem;

  /deep/ p {
    margin: 0;
  }
}

.contentUs {
  margin-top: 20px;
}

.tel {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 30px;
}

.telIcon {
  display: block;
  width: 1em;
}

.bottom {
  position: absolute;
  bottom: 1px;
  width: 100%;
}

/* .shareIcon {
  width: 1em;
}
.share {
  float: left;
  width: 30%;
  background-color: white;
  font-size: 1.1rem;
  font-weight: bold;
  text-align: center;
  padding: 10px 0px 10px 0px;
  color: #00706E;
} */
.donating {
  float: right;
  width: 100%;
  text-align: center;
  font-size: 1.1rem;
  font-weight: bold;
  padding: 10px 0px 10px 0px;
  background: linear-gradient(270deg, #00706e, #00706e);
  color: white;
}

.popup {
  position: relative;
}

.topImgDiv {
  width: 100%;
}

.topImg {
  width: 100%;
}

.bottomImgDiv {
  width: 100%;
}

.bottomImg {
  width: 100%;
  position: absolute;
  top: 100%;
  transform: translateY(-100%);
}

.popupExplain {
  font-size: 1.2em;
  color: #00706e;
  text-align: center;
  font-weight: bold;
}

.popupExplainWords {
  position: relative;
  left: 5%;
  width: 90%;
  height: 67%;
  overflow-y: scroll;
}

.popupExplainWords::-webkit-scrollbar {
  display: none;
}

.popupWelfareExplainWords {
  position: relative;
  left: 5%;
  top: 5%;
  width: 90%;
  overflow-y: scroll;
  background-color: #f5f5f5;
  border-radius: 15px;
}

.popupWelfareName {
  font-size: 1.1em;
  color: #333333;
  font-weight: bold;
  padding: 10px 0px 5px 10px;
}

.popupWelfareAdress {
  color: #666666;
  padding: 5px 0px 5px 10px;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.popupWelfareService {
  color: #666666;
  padding: 5px 10px 10px 10px;
}

.popupWelfareTips {
  position: relative;
  top: 15%;
  text-align: center;
  font-size: 1.1em;
  color: #333333;
  font-weight: bold;
}

.popupWelfareBtnDiv {
  position: absolute;
  top: 72%;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
}

.popupBtnDiv {
  position: absolute;
  top: 82%;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
}

.popupBtn {
  width: 100%;
  border: 0;
  background: linear-gradient(270deg, #00706e, #00706e);
  font-size: 1.2em;
  font-weight: bold;
  color: white;
  padding: 8px 0 8px 0;
  border-radius: 45px;
}

.showDonating {
  position: relative;
}

.part {
  position: relative;
  left: 5%;
  width: 90%;
  margin-top: 30px;
  border: 1px solid #00706e;
  border-radius: 5px;
}

.partTitle {
  float: left;
  padding: 10px 0px 10px 10px;
  text-align: center;
  font-size: 1.1rem;
  font-weight: bold;
}

.partNum {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  float: right;
}

.customMoney {
  width: 90%;
  position: relative;
  left: 5%;
  margin-top: 20px;
}

/deep/.el-input__suffix-inner {
  position: relative;
}

.customMoneyUnit {
  font-style: normal;
  position: relative;
  top: 25%;
  margin-right: 5px;
}

.showButtonDiv {
  position: relative;
  margin-top: 30px;
}

.showBtn {
  background: linear-gradient(270deg, #00706e, #00706e);
  border-radius: 45px;
  border: 0px;
  width: 90%;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 0px;
  margin-bottom: 20px;
  font-weight: bold;
  color: #ffffff;
  font-size: 1.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/donation/DonationDetail.vue